import { PortalModule } from '@angular/cdk/portal';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  QueryList,
  ViewEncapsulation,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { LeftPanelComponent } from '../../component/layout/left-panel/left-panel.component';
import { RightPanelComponent } from '../../component/layout/right-panel/right-panel.component';
import { TopPanelComponent } from '../../component/layout/top-panel/top-panel.component';
import { RoutingService } from '../../services/routing.service';

@Component({
  selector: 'layout',
  imports: [PortalModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class LayoutComponent implements AfterContentInit {
  @ContentChildren(TopPanelComponent, { descendants: false }) topPanels!: QueryList<TopPanelComponent>;
  @ContentChildren(LeftPanelComponent, { descendants: false }) leftPanels!: QueryList<LeftPanelComponent>;
  @ContentChildren(RightPanelComponent, { descendants: false }) rightPanels!: QueryList<RightPanelComponent>;

  private _routingService = inject(RoutingService);

  hasTopPanel = false;
  hasLeftPanel = false;
  hasRightPanel = false;

  public isMobile = this._routingService.$isMobile;

  ngAfterContentInit() {
    // Check for direct children panel components
    this.hasTopPanel = this.topPanels?.length > 0;
    this.hasLeftPanel = this.leftPanels?.length > 0;
    this.hasRightPanel = this.rightPanels?.length > 0;
  }
}
